import { render, staticRenderFns } from "./ItemWave.vue?vue&type=template&id=7abf34d0&scoped=true&"
import script from "./ItemWave.vue?vue&type=script&lang=js&"
export * from "./ItemWave.vue?vue&type=script&lang=js&"
import style0 from "./ItemWave.vue?vue&type=style&index=0&id=7abf34d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abf34d0",
  null
  
)

export default component.exports